/**
 * Common GROQ query fragments for reusable patterns.
 * Used by industry, product, resources and other query modules.
 */
export const FRAGMENTS = {
  responsivePadding: `{
    mobile { paddingTop, paddingRight, paddingBottom, paddingLeft },
    tablet { paddingTop, paddingRight, paddingBottom, paddingLeft },
    laptop { paddingTop, paddingRight, paddingBottom, paddingLeft },
    desktop { paddingTop, paddingRight, paddingBottom, paddingLeft }
  }`,
  responsiveValue: `{ mobile, tablet, laptop, desktop }`,
  imageWithMetadata: `{
    asset,
    alt,
    "metadata": asset->metadata {
      dimensions
    }
  }`,
  link: `{
    href,
    nofollow,
    blank
  }`,
  resourceFields: `{
    _id,
    title,
    publishedAt,
    slug,
    category->{ title },
    author->{ _id, name, image },
    "slug": slug.current,
    preview,
    mainImage{ alt, name, asset },
    tag[]->{ _id, name },
    timeToRead
  }`,
  resourceWithMetadata: `{
    _id,
    title,
    "slug": slug.current,
    preview,
    mainImage {
      asset,
      alt,
      "metadata": asset->metadata {
        dimensions
      }
    },
    author->{ name },
    category->{ title },
    timeToRead
  }`,
} as const;
